import { ValidatePhoneNumber } from '@components/ValidatePhone/ValidatePhoneNumber';
import { EnterPhoneNumber } from '@components/EnterPhoneNumber/EnterPhoneNumber';
import { PhoneValidationStep } from '@app/pages/Phone/PhoneValidationStep';
import { usePhonePageController } from '@app/pages/Phone/UsePhonePageController';

export const PhonePage = () => {
  const {
    resetError,
    error,
    errorMessage,
    step,
    phoneNumber,
    onPhoneNumberChange,
    onCodeComplete,
    onTryAgain,
    onTryDifferentNumber,
    onResendCode,
  } = usePhonePageController();
  return (
    <>
      <EnterPhoneNumber
        onChange={onPhoneNumberChange}
        visible={step === PhoneValidationStep.EnterPhoneNumber}
        phoneNumber={phoneNumber}
      ></EnterPhoneNumber>
      <ValidatePhoneNumber
        resetError={resetError}
        errorMessage={errorMessage}
        error={error}
        phoneNumber={phoneNumber}
        visible={step === PhoneValidationStep.ValidatePhoneNumber}
        onResendCode={onResendCode}
        validateCode={onCodeComplete}
        onTryAgain={onTryAgain}
        onTryDifferentNumber={onTryDifferentNumber}
      ></ValidatePhoneNumber>
    </>
  );
};
